import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    
        {
            "Name": "Vikas Kumar Sahu",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2023",
            "AreasofResearch": "Low-dimensional and frustrated Quantum Spin Systems",
            "GuideName": "Dr. Koteswara Rao Bommisetti",
            "GuideLink": "/dr-koteswara-rao-bommisetti",
            "Email": "ph23d006@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Vikas Kumar Sahu.png"
        },
        {
            "Name": "Arpita Goswami",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2023",
            "AreasofResearch": "Theoretical Condensed Matter Physics",
            "GuideName": "Dr. Shaon Sahoo",
            "GuideLink": "/dr-shaon-sahoo",
            "Email": "ph23d007@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Arpita Goswami.png"
        },
        {
            "Name": "Nripendra Majumdar",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2023",
            "AreasofResearch": "Quantum information theory and computation",
            "GuideName": "Dr. S. Aravinda",
            "GuideLink": "/dr-aravinda-s",
            "Email": "ph23d008@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Nripendra Majumdar.png"
        },
        {
            "Name": "Vineeta Yadav",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2023",
            "AreasofResearch": "Strongly correlated systems with large spin-orbit coupling",
            "GuideName": "Dr. Rudra Sekhar Manna",
            "GuideLink": "/dr-rudra-sekhar-manna",
            "Email": "ph23d009@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Vineeta Yadav.png"
        },
        {
            "Name": "Mr. Rishabh Pal",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Experimental Atomic, Molecular and Optical Physics - Quantum Optics, Precision Laser Spectroscopy, Quantum Metrology",
            "GuideName": "Dr. Arijit Sharma",
            "GuideLink": "/dr-arijit-sharma",
            "Email": "ph22d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Rishabh.jpg"
        },
        {
            "Name": "Ms. Sneha S",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Experimental Atomic, Molecular and Optical Physics - Quantum Optics, Precision Laser Spectroscopy, Quantum Metrology",
            "GuideName": "Dr. Arijit Sharma",
            "GuideLink": "/dr-arijit-sharma",
            "Email": "ph22d503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Sneha.jpg"
        },
        {
            "Name": "Mr. Sonu Jana",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Experimental Atomic, Molecular and Optical Physics - Quantum Optics, Precision Laser Spectroscopy, Quantum Metrology",
            "GuideName": "Dr. Arijit Sharma",
            "GuideLink": "/dr-arijit-sharma",
            "Email": "ph22d504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Sonu Jana.jpg"
        },
        {
            "Name": "Mr. Thota Satish Babu",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Plasma Physics, Atomic and Molecular Physics",
            "GuideName": "Dr. Reetesh Kumar Gangwar & Dr. Shihabudheen M. Maliyekkal",
            "Email": "ph22d505@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Satish Babu.jpg"
        },
        {
            "Name": "Mr. Vikrant Yadav",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Experimental Atomic, Molecular and Optical Physics - Quantum Optics, Precision Laser Spectroscopy, Quantum Metrology",
            "GuideName": "Dr. Arijit Sharma",
            "GuideLink": "/dr-arijit-sharma",
            "Email": "ph22d506@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Vikrant Yadav.jpg"
        },
        {
            "Name": "Ms. Pallabi Chatterjee",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2022",
            "AreasofResearch": "Theoretical Condensed Matter Physics",
            "GuideName": "Dr. Ranjan Krishna Modak",
            "GuideLink": "/dr-ranjan-modak",
            "Email": "ph22d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Pallabi.png"
        },
        {
            "Name": "Mr. Rahul V",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2022",
            "AreasofResearch": "Quantum Information and Quantum computation",
            "GuideName": "Dr. Aravinda S",
            "GuideLink": "/dr-aravinda-s",
            "Email": "ph22d002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Rahul.png"
        },
        {
            "Name": "Mr. Abhijit Kundu",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021",
            "AreasofResearch": "Experimental Atomic Molecular and Optical Physics",
            "GuideName": "Dr. Arijit Sharma",
            "GuideLink": "/dr-arijit-sharma",
            "Email": "ph21d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Abhijit.png"

        },
        {
            "Name": "Mr. Sumit Achar",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021",
            "AreasofResearch": "Experimental Atomic Molecular and Optical Physics",
            "GuideName": "Dr. Arijit Sharma",
            "GuideLink": "/dr-arijit-sharma",
            "Email": "ph21d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Sumit.png"
        },
        {
            "Name": "Ms. Indhu Suresh",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "Atomic and Molecular Physics, plasma physics",
            "GuideName": "Dr. Reetesh Kumar G",
            "GuideLink": "/dr-reetesh-kumar-gangwar",
            "Email": "ph20d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Indhu.png"
        },
        {
            "Name": "Ms. Smitarani Mishra",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "Theoritical condensed matter physics",
            "GuideName": "Dr. Shaon Sahoo",
            "GuideLink": "/dr-shaon-sahoo",
            "Email": "ph20d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Smitarani.png"
        },
        {
            "Name": "Mr. Vaibhav Kumar Singh",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "Quantum Spin Liquids and Multiferroics",
            "GuideName": "Dr. B. Koteswara Rao",
            "GuideLink": "/dr-koteswara-rao-bommisetti",
            "Email": "ph20d504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/Vaibhav.png"
        },
        {
            "Name": "P S Naga Sai Raghavendra Srikar",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Plasma Physics, Atomic and Molecular Physics",
            "GuideName": "Dr. Reetesh Kumar Gangwar",
            "Email": "ph19d503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/srikar.jpg"
        },
        {
            "Name": "Hareesh.C",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Theoretical Ultrafast Physics",
            "GuideName": "Dr. Vinay Pramod Majety",
            "Email": "ph19d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ph/hareesh.jpeg"
        },
        {
            "Name": "Sromona Nandi",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Magnetism and Superconductivity",
            "GuideName": "Dr. Rudra Sekhar Manna",
            "Email": "ph18d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/PH18D501_SromonaNandi.jpg"
        },
        {
            "Name": "Boya Krishnamraju",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2018",
            "AreasofResearch": "Strongly Correlated Electron Systems, Quantum Spin Liquids",
            "GuideName": "Dr. Koteswara Rao Bommisetti",
            "Email": "ph18d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/krishnamraju.png"
        },
        {
            "Name": "Voma Uday Kumar",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2018",
            "AreasofResearch": "Strongly Correlated Electron Systems",
            "GuideName": "Dr. Koteswara Rao Bommisetti",
            "Email": "uday@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/Uday.jpg"
        }





]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Physics" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Physics</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (


                            <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>

                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>

                                            {/* Parse the HTML content and extract text */}

                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}



                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main